import React from 'react';

import {ButtonBack, ButtonNext, Dot} from "pure-react-carousel";

const renderDots = (props) => {
    const {
        currentSlide,
        totalSlides,
        visibleSlides,
        disableActiveDots,
        showAsSelectedForCurrentSlideOnly,
    } = props;

    const dots = [];
    for (let i = 0; i < totalSlides; i += 1) {
        const multipleSelected = i >= currentSlide && i < (currentSlide + visibleSlides);
        const singleSelected = i === currentSlide;
        const selected = showAsSelectedForCurrentSlideOnly ? singleSelected : multipleSelected;
        const slide = i >= totalSlides - visibleSlides ? totalSlides - visibleSlides : i;
        dots.push(
            <li className={`page-item d-none d-md-inline-block ${selected && 'active'}`} key={i}>
                <Dot
                    slide={slide}
                    selected={selected}
                    disabled={disableActiveDots ? selected : false}
                    className={'page-link'}
                >
                    <span className={'carousel__dot-group-dot'}>{i + 1}</span>
                </Dot>
            </li>,
        );
    }
    return <ul className={'pagination'}>
        <li className={'page-item'}>
            <ButtonBack className={'page-link'}>&larr;</ButtonBack>
        </li>
        {dots}
        <li className={'page-item'}>
            <ButtonNext className={'page-link'}>&rarr;</ButtonNext>
        </li>
    </ul>;
};

export default renderDots;
